const isDev = process.env.VUE_APP_ENV === "development";
const isProduction = process.env.VUE_APP_ENV === "production";
const isLocal = process.env.VUE_APP_ENV === "local";

export { isDev, isProduction, isLocal };
